import styled from 'styled-components'
import { Card } from '@aragon/ui'

const EmptyBlock = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 180px;
`

export default EmptyBlock
